<template>
  <v-container fluid>
    <v-dialog v-model="dialog" v-if="dialog" max-width="40vw" persistent>
      <EditEmployee 
        :employeeDetails="employee" 
        :head="headAgent"
        :isUpdating="isUpdating"
        @close="close"
        @saved="close"
      ></EditEmployee>
    </v-dialog>

    <v-title>Employees</v-title>
    <div>
      <v-layout row wrap justify="end">
        <v-flex xs4>
          <v-text-field
            name="Search"
            label="Search"
            v-model="SearchText"
            append-icon="search"
          ></v-text-field>
        </v-flex>
        <v-flex style="text-align: right;">
          <v-btn
            @click="addNewEmployee"
            color="primary"
          >
            Add Employee
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    
    <ag-grid-vue
      domLayout="autoHeight"
      class="ag-theme-balham"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :defaultColDef="defaultColDef"
      :frameworkComponents="frameworkComponents"
      @first-data-rendered="onFirstDataRendered"
      @grid-ready="onGridReady"
      pagination
      :paginationPageSize="10"
    ></ag-grid-vue>
    <v-layout row>
      <v-flex xs12>
        <message-alert :component="message"></message-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapEmployeeActions } = createNamespacedHelpers(`orders/employee`);
import AuthDetails from '@/components/admin/auth-details';
import { AgGridVue } from "ag-grid-vue";
import EditEmployee from '../components/admin/employee/EditEmployee.vue'
import TableActions from '../components/admin/employee/TableActions.vue'
import { Employee } from '../models/Employee';
import { httpError } from '../models/httpError';
import { mapEmployeeFields } from "@/store/modules/orders";

export default {
  name: 'employees',
  components: {
    AuthDetails,
    AgGridVue,
    EditEmployee,
    TableActions
  },
  data: () => ({
    gridOptions: null,
    columnDefs: null,
    defaultColDef: null,
    rowData: null,
    gridApi: null,
    columnApi:null,
    frameworkComponents: null,
    dialog: false,
    employee: {},
    headAgent: null,
    isUpdating: false,
    SearchText: null,
  }),
  computed: {
    ...mapEmployeeFields(['message']),
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: 'ID',
        field: 'id',
        sortable: true,
        filter: true,
        width: 90,
        valueGetter: (params) => {
          return params.data.employee.id
        }
      },
      {
        headerName: 'Dealer ID',
        field: 'dealerID',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: (params) => {
          return params.data.employee.dealerID
        }
      },
      {
        headerName: 'First Name',
        field: 'firstName',
        sortable: true,
        filter: true,
        valueGetter: (params) => {
          return params.data.employee.firstName
        }
      },
      {
        headerName: 'Last Name',
        field: 'lastName',
        sortable: true,
        filter: true,
        valueGetter: (params) => {
          return params.data.employee.lastName
        }
      },
      {
        headerName: 'Email',
        field: 'email',
        sortable: true,
        filter: true,
        valueGetter: (params) => {
          return params.data.employee.email
        }
      },
      {
        headerName: 'Authority Level',
        field: 'authorityLevel',
        sortable: true,
        filter: true,
        width: 130,
        valueGetter: (params) => {
          return params.data.employee.authorityLevel
        }
      },
      {
        headerName: 'Job Title',
        field: 'jobTitle',
        sortable: true,
        filter: true,
        valueGetter: (params) => {
          return params.data.employee.jobTitle
        }
      },
      {
        headerName: 'Login Status',
        field: 'loginStatus',
        sortable: true,
        filter: true,
        width: 110,
        valueGetter: (params) => {
          return params.data.employee.loginStatus
        }
      },
      {
        headerName: 'UBDealerID',
        field: 'headDealer',
        sortable: true,
        filter: true,
        width: 110
      },
      {
        headerName: "Actions",
        cellRenderer: "tableActions",
        width: 110,
        suppressSizeToFit: true,
        cellRendererParams: {
          clicked: function (param) {
            vm.onEditEmployee(param)
          },
        },
      },
    ];
    vm.frameworkComponents = {
      tableActions: TableActions,
    };
    vm.defaultColDef = {
      autoHeight: true,
    };
  },
  methods: {
    ...mapEmployeeActions([
      'getEmployees',
      'setMessage'
    ]),
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
    onFirstDataRendered (grid) {
      grid.api.sizeColumnsToFit();
    },
    close() {
      let vm = this
      vm.employee = new Employee()
      vm.isUpdating = false
      vm.dialog = false
      vm.getEmployeesAsync()
    },    
    addNewEmployee() {
      this.employee = new Employee()
      this.headAgent = 0
      this.isUpdating = false
      this.dialog = true
    },
    onEditEmployee(data) {
      this.employee = data.employee
      this.headAgent = data.headDealer
      this.isUpdating = true
      this.dialog = true
    },
    getEmployeesAsync() {
      let vm = this;
      vm.getEmployees().then(data => {
        vm.rowData = data
      })
    }
  },
  watch: {
    SearchText(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
  mounted() {
    let vm = this;
    this.$nextTick(() => {
      vm.setMessage(new httpError());
      vm.getEmployeesAsync()
    });
  },
};
</script>
